import { useCoreSelector } from '../../CoreStore';

import type { CustomPopup } from './types';

export const usePopupSlice = {
  currentPopup: (): string | null => {
    return useCoreSelector(({ popup }) => popup.currentPopup?.popupName || null);
  },
  currentPopupData: (): Record<string, unknown> | null => {
    return useCoreSelector(({ popup }) => popup.currentPopup?.popupData || null);
  },
  customPopup: (): CustomPopup | null => {
    return useCoreSelector(({ popup }) => popup.customPopup);
  },
};
